<script lang="ts" setup>
import { useSiteOperationalDataStore } from "../../store/siteOperationalData.store";
import { computed, onMounted, ref } from 'vue';
import i18n from "../../i18n/index";
import CbCenter from "../../components/Header/CbCenter.vue";

const siteOperationalStore = useSiteOperationalDataStore();
const maDate = new Date();
var dateyear = computed(() => i18n.global.d(maDate, "longString"));

</script>
<template>
    <header class="header">
        <p class="header__title">
            <span class="header__title--bold">O2S - </span>
            {{ siteOperationalStore.currentPage }}
        </p>
        <p class="header__date">{{  dateyear }}</p>
        <div class="header__right">
            <CbCenter/>
        </div>
    </header>
</template>

<style lang="scss">
@use "../../assets/css/utils/_variables.scss" as *;

.header {
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  box-sizing: border-box;
  background-color: $white;
  box-shadow: $box-shadow-s;
  z-index: 4;

  &__title {
    margin-left: 40px;
    &--bold {
      font-weight: 700;

      @media screen and (max-width: 600px) {
        font-size: 0.9rem;
        font-weight: 400;
      }
    }
  }

  &__date {
    font-size: 1.25rem;
    font-weight: 700;

    @media screen and (max-width: 600px) {
      display: none;
    }
  }

  &__right {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;

    &-logo {
      margin: 0;
      height: 100%;
      width: auto;
      display: flex;
    }

    .dropdown {
      margin: 0 16px;

      &-button--active {
        background-color: $white-blue;
        color: $dark-grey;

        &:hover {
          .dropdown__line-img,
          .dropdown-button--chevron {
            filter: unset;
          }
        }
      }
    }

    .dropdown-button__container__list--img {
      filter: brightness(0.3) saturate(100%);
    }
  }

  .dropdown-button__container--list {
    padding: 16px;
  }
}
</style>